import { IGraphqlMockResponse } from '@thx/providers/angular';

const mocks: IGraphqlMockResponse[] = [];

export const appMocks = new Map<string, object>(
  mocks.map((mock) => [mock.operation, { payload: mock.payload, useMock: mock.useMock }]),
);
